/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListBrandsQueryResponse,
  ListBrandsQueryParams,
} from '../../types/ListBrands'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listBrands } from '../../clients/listBrands'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listBrandsQueryKey = (params?: ListBrandsQueryParams) =>
  [
    { url: '/api/v1/products/catalog/brands/' },
    ...(params ? [params] : []),
  ] as const

export type ListBrandsQueryKey = ReturnType<typeof listBrandsQueryKey>

export function listBrandsQueryOptions(
  params?: ListBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listBrandsQueryKey(params)
  return queryOptions<
    ListBrandsQueryResponse,
    ResponseErrorConfig<Error>,
    ListBrandsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listBrands(params, { ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @description Architecture: READ operation - uses pure DRF pattern.
 * Uses DRF's built-in retrieve() method.
 * @summary List brands
 * {@link /api/v1/products/catalog/brands/}
 */
export function useListBrands<
  TData = ListBrandsQueryResponse,
  TQueryData = ListBrandsQueryResponse,
  TQueryKey extends QueryKey = ListBrandsQueryKey,
>(
  params?: ListBrandsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListBrandsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listBrandsQueryKey(params)

  const query = useQuery(
    {
      ...listBrandsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
